export interface ApiResult {
    success: boolean;
    code: string;
    message: string;
}

export namespace ApiResult {
    export const success = (message = ''): ApiResult => ({ success: true, code: '0', message });
    export const error = (message = '', code = ''): ApiResult => ({ success: false, code, message });
}
